import axios from "../axios";
const END_POINT = "/roles";

const getRoles = () => axios.get(`${END_POINT}`);
const searchRoles = (payload) => axios.post(`${END_POINT}/search`, payload);

export {
  getRoles,
  searchRoles
};
